// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/service/stylesheet/index.scss
 ** module id = 462
 ** module chunks = 1
 **/